import BasicRouterView from "../../components/BasicRouterView.vue";

const pickingRoutes = {
  path: "pkg",
  redirect: { name: "pkg-criacao" },
  meta: {
    label: "Picking",
    icon: "pinch",
    show: true,
    tabsShow: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "picking/criacao-picking",
      name: "pkg-criacao",
      meta: {
        label: "Criação de Picking",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/CriacaoPicking.vue"),
    },
    {
      path: "picking/criacao-picking-nova",
      name: "pkg-criacao-nova",
      meta: {
        label: "Criação de Picking Nova",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/CriacaoPickingNova.vue"),
    },
    {
      path: "picking/detalhe-nova/:id",
      name: "pkg-detalhe-nova",
      meta: {
        label: "Listagem de Picking",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/DetalhePickingNova.vue"),
    },
    {
      path: "picking/detalhe/:id",
      name: "pkg-detalhe",
      meta: {
        label: "Listagem de Picking",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/DetalhePicking.vue"),
    },
    {
      path: "picking/listagem-picking",
      name: "pkg-listagem",
      meta: {
        label: "Listagem de pickings",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ListagemPicking.vue"),
    },
    {
      path: "picking/listagem-picking-nova",
      name: "pkg-listagem-nova",
      meta: {
        label: "Listagem de pickings Nova",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ListagemPickingNova.vue"),
    },
    {
      path: "picking/detalhe-transferencia/:id",
      name: "pkg-detalhe-transferencia",
      meta: {
        label: "Detalhe Transferencia",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pkg" */ "./views/DetalheTransferencia.vue"
        ),
    },
    {
      path: "picking/detalhe-transferencia-nova/:id",
      name: "pkg-detalhe-transferencia-nova",
      meta: {
        label: "Detalhe Transferencia",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pkg" */ "./views/DetalheTransferenciaNova.vue"
        ),
    },
    {
      path: "picking/integracao-picking",
      name: "pkg-integracao",
      meta: {
        label: "Acompanhamento Integração",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/IntegracaoPicking.vue"),
    },
    {
      path: "picking/controle-tempo/:id?",
      name: "pkg-controle-tempo",
      meta: {
        label: "Relatorio Controle de Tempo",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ControleTempo.vue"),
    },
    {
      path: "picking/controle-tempo-nova/:id?",
      name: "pkg-controle-tempo-nova",
      meta: {
        label: "Relatorio Controle de Tempo Nova",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ControleTempoNova.vue"),
    },
    {
      path: "picking/relatorio-integracao/:id?",
      name: "pkg-relatorio-integracao",
      meta: {
        label: "Relatorio Integração",
        icon: "find_in_page",
        show: true,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/RelatorioIntegracao.vue"),
    },
    {
      path: "picking/imprimir-picking/:id",
      name: "pkg-imprimir",
      meta: {
        label: "Imprimir Picking",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/ImprimirPicking.vue"),
    },
    {
      path: "picking/imprimir-picking-agrupado/:id",
      name: "pkg-imprimir-agrupado",
      meta: {
        label: "Imprimir Picking Agrupado",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "pkg" */ "./views/ImprimirPickingAgrupado.vue"
        ),
    },
    {
      path: "picking/historico/:voucherId",
      name: "pkg-historico",
      meta: {
        label: "Histórico Picking",
        icon: "find_in_page",
        show: false,
      },
      component: () =>
        import(/* webpackChunkName: "pkg" */ "./views/HistoricoPicking.vue"),
    },
  ],
};

export default pickingRoutes;
